import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconRejectSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.52437 4.25479C8.39798 4.09393 8.20474 4 8.00016 4C7.79559 4 7.60234 4.09393 7.47595 4.25479L3.80928 8.92145C3.65161 9.12213 3.62234 9.39522 3.7339 9.62476C3.84546 9.8543 4.07828 10 4.3335 10H11.6668C11.922 10 12.1549 9.8543 12.2664 9.62476C12.378 9.39522 12.3487 9.12213 12.191 8.92145L8.52437 4.25479ZM10.2952 8.66667H5.70514L8.00016 5.74573L10.2952 8.66667ZM4.00016 11.3333C3.63197 11.3333 3.3335 11.6318 3.3335 12C3.3335 12.3682 3.63197 12.6667 4.00016 12.6667H12.0002C12.3684 12.6667 12.6668 12.3682 12.6668 12C12.6668 11.6318 12.3684 11.3333 12.0002 11.3333H4.00016Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
